import { v4 as uuid } from "uuid";
import StorageContants from "../config/storage.constants";
import LocalStorage from "../call-sdk/lib/local-storage";
import { UUID } from "../types";
import * as Sentry from "@sentry/react";

export function generateDeviceId(): UUID {
  const deviceId = uuid();
  LocalStorage.set(StorageContants.UNIQUE_DEVICE_ID, deviceId);
  return deviceId;
}

export function getDeviceId(): UUID {
  const deviceId = LocalStorage.get(StorageContants.UNIQUE_DEVICE_ID);
  if (!deviceId) {
    Sentry.captureException(new Error("Device ID not found in localStorage"));
    return "";
  }
  return deviceId;
}
